import React, {useEffect} from 'react';
import {Button, Divider, Space, Spin} from 'antd';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {QuestionApi} from '../../scaffold';
import Flex from '../Shared/Flex';
import CodingQuestionContentSection from '../Question/CodingQuestionContentSection';
import CodingQuestionAnswerSection from '../Question/CodingQuestionAnswerSection';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function CourseQuestionDetail(props: {detailId: number; solved: () => any}) {
  const queryByIdHook = useOpenApiFpRequest(QuestionApi, QuestionApi.prototype.questionFindCodingQuestionGet);
  const question = queryByIdHook.data;
  useEffect(() => {
    if (props.detailId) {
      queryByIdHook.request({id: props.detailId}).catch(CommonApiErrorHandler);
    }
  }, [props.detailId]);

  return (
    <div>
      {queryByIdHook.loading ? (
        <Flex align={'center'} justify={'center'} style={{height: 500}}>
          <Spin size={'large'} tip={'加载中'} />
        </Flex>
      ) : (
        <div>
          {question && (
            <div>
              <Flex className={'p-20 b-b-1'} justify={'space-between'} align={'center'}>
                <div>
                  <Title level={3} style={{marginBottom: 5}}>
                    {question.topic}
                  </Title>
                </div>
                <div>
                  <a href={`/question/${question.id}/submission`} target={'_blank'}>
                    <Button className={'mb-sm'} style={{width: 200, display: 'block'}}>
                      查看全部提交记录
                    </Button>
                  </a>
                </div>
              </Flex>
              <div className={'p-20 b-b-1'}>
                <CodingQuestionContentSection question={question} />
              </div>
              <div className={'p-20'}>
                <CodingQuestionAnswerSection question={question} solved={props.solved} />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
